import type { FC } from 'react';
import React, { useState } from 'react';
import styled from 'styled-components';

import type { IMetapolicies } from './types';

import { getLabelOfCalculationType } from './utils';

import {
  formatCurrency,
  formatCurrencyWithName,
} from '../../utils/stringUtils';

const Metapolicies: FC<IMetapolicies> = ({
  metapolicies,
  isMobile,
  showLabels = true,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const shownMetapolicies = isCollapsed
    ? metapolicies.slice(0, 3)
    : metapolicies;

  return (
    <StyledWrapper>
      <StyledTitle isMobile={isMobile}>Оплачивается на месте</StyledTitle>
      <StyledList isMobile={isMobile}>
        {shownMetapolicies.map(
          ({
            name,
            price,
            currency,
            price_converted,
            calculation_type,
            id,
          }) => {
            const formattedCurrency = formatCurrencyWithName(price, currency);
            const label = showLabels
              ? getLabelOfCalculationType(calculation_type)
              : '';

            return (
              <li key={id}>
                {`${name} — `}
                <StyledPrice isMobile={isMobile}>
                  {`${formattedCurrency}${label} `}
                  {currency === 'RUB' ? null : (
                    <StyledConvertedPrice isMobile={isMobile}>
                      {`(${formatCurrency(price_converted)})`}
                    </StyledConvertedPrice>
                  )}
                </StyledPrice>
              </li>
            );
          },
        )}
        {isCollapsed && metapolicies?.length > 3 ? (
          <StyledUncollapseText onClick={() => setIsCollapsed(false)}>
            Показать все
          </StyledUncollapseText>
        ) : null}
      </StyledList>
    </StyledWrapper>
  );
};

const StyledTitle = styled.h5<{ isMobile?: boolean }>`
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${(props) => props.theme.colors.blackBase};
  ${(props) => props.theme.typography.headline6}
`;

const StyledList = styled.ul<{ isMobile?: boolean }>`
  margin-top: 8px;
  ${({ isMobile }) => (isMobile ? 'margin-bottom: 16px;' : null)}
  li {
    color: #4d4d4d;
    font-size: 14px;
    margin-bottom: ${({ isMobile }) => (isMobile ? '8' : '4')}px;
    :last-of-type {
      ${({ isMobile }) => isMobile && 'margin-bottom: 16px;'}
    }
  }
`;

const StyledWrapper = styled.div`
  margin-top: 16px;
`;

const StyledUncollapseText = styled.span`
  cursor: pointer;
  color: #007aff;
`;

const StyledPrice = styled.span<{ isMobile?: boolean }>`
  white-space: nowrap;
  font-weight: bold;
`;

const StyledConvertedPrice = styled.span<{ isMobile?: boolean }>`
  font-weight: normal;
  color: #919499;
`;

export default Metapolicies;
